import { ChartJSActiveElementObserver } from './ChartJSActiveElementObserver';

type IUnsubscribe = () => void;

export class ChartLineAndChartActiveElementSynchronizer {
    constructor(
        private lineCanvas: HTMLCanvasElement,
        private color: string,
        private activeElementObserver: ChartJSActiveElementObserver
    ) { }
    synchronize = (): IUnsubscribe => {
        this.drawLine();

        return this.activeElementObserver.subscribe(() => {
            this.drawLine();
        });
    };

    private x?: number;
    private y?: number;

    private drawLine = () => {
        const context = this.lineCanvas!.getContext('2d')!;

        if (this.activeElementObserver.state.active) {
            const { x, y } = this.activeElementObserver.state.active;

            // if already there, do nothing (and stop recursing every 100ms)
            if (y === this.y && x === this.x) {
                return;
            }

            context.clearRect(0, 0, this.lineCanvas!.width, this.lineCanvas!.height);

            context.beginPath();
            context.moveTo(x, 0);

            context.lineTo(x, y);
            this.y = y;
            this.x = x;

            context.strokeStyle = this.color;
            context.lineWidth = 8;
            context.stroke();
        }
    };
}
